angular.module('CarsSaraBo').directive('saraStepper', function () {
	return {
		restrict: 'E',
		controller: [SaraStepperController],
		controllerAs: 'ctrl',
		bindToController: {
			messages: '=',
			output: '=',
			error: '=',
			name: '=',
			typeAmount: '=',
			min: '=',
			max: '='
		},
		templateUrl: 'templates/commons/form/stepper/stepper.component.html',
		scope: {} // isolated scope
	};
});

function SaraStepperController() {
	var vm = this;

	vm.updateValidation = function () {
		if (vm.error != undefined) {
			vm.error = null;
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/app/commons/form/stepper/stepper.component.js
// module id = 926
// module chunks = 3